import './App.css'
import Home from './Home'
import { Routes, Route } from 'react-router-dom'
import Art from './Art.js'
import About from './About.jsx'
import Gallery from './gallery.jsx'
import Profile from './Profile.jsx'
import Work from './Work.jsx'

function App() {
  return (
    <div className="App">
      <Home />
    </div>
  )
}

export default App
